import { AgentStatuses } from '@insurance/types'
import { Tag, TagProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  status?: AgentStatuses
}

const statusColors: Record<AgentStatuses, TagProps['color']> = {
  [AgentStatuses.ACTIVE]: 'green',
  [AgentStatuses.DISABLED]: 'red',
  [AgentStatuses.PENDING]: 'yellow',
  [AgentStatuses.DELETED]: 'volcano'
}

export const AgentStatusTag = ({ status }: Props) => {
  const { t } = useTranslation()

  if (!status) return null

  return <Tag color={statusColors[status]}>{t(status)}</Tag>
}
